import React from 'react'
import { Button } from '@alifd/next'
import styles from './index.module.scss'
import { research } from 'portal/assets/images/index'

interface ProjectProps {
  image: string,
  title:string,
  time: string,
  cases: string,
  status: string,
}
export default function ResearchProjects() {
  const project: ProjectProps[] = [
    {
      image: research,
      title: '宋基会-慢阻肺急性加重患者的注册登记研究平台',
      time: '2019-01-15',
      cases: '8219',
      status: '2020-6-1使用过',
    },
    {
      image: research,
      title: '中国成人肺部健康研究队列',
      time: '2016-03-13',
      cases: '1791',
      status: '2020-7-10查看过',
    },
    {
      image: research,
      title: '中国职业性尘肺病队列研究',
      time: '2017-05-20',
      cases: '5435',
      status: '猜你感兴趣',
    }
  ]

  function researchProject(props: ProjectProps) {
    const { image, title, time, cases, status } = props
    return (
      <div className={ styles.projectCard }>
        <img src={ image } alt="科研项目" style={{ margin: 20 }} />
        <h5 style={{ lineHeight: '22px', height: 58, color: '#202d4c' }}>{ title }</h5>
        <p>启动时间：{ time }</p>
        <p style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>入组病例数：{ cases }</span>
          <span>{ status }</span>
        </p>
      </div>
    )
  }
  return (
    <div className={ styles.researchProject}>
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '30px 0' }}>
        <h2>科研项目<span> Research Projects</span></h2>
        <div className={ styles.buttons } style={{ paddingTop: 14 }}>
          <Button type="primary">为你推荐</Button>
          <a href="/apps/dsp?path=/studies" target="_blank" rel="noopener noreferrer">
            <Button style={{ border: 'none', background: 'none', color: '#202d4c' }}>公开项目</Button>
          </a>
          <Button style={{ border: 'none', background: 'none', color: '#202d4c' }}>我的项目</Button>
        </div>
      </div>
      <div className={ styles.projectContent }>
        { project.map(researchProject) }
      </div>
    </div>
  )
}
